import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';

import { filterDefined } from '@core/common-legacy';
import { JobItemsSelectors } from '@core/offers-data';

@Injectable({ providedIn: 'root' })
export class ActiveJobsDataService {
  private readonly store = inject(Store);

  public readonly data$ = this.store
    .select(JobItemsSelectors.active)
    .pipe(filterDefined, shareReplay({ bufferSize: 1, refCount: true }));
}
